import React from 'react';
import './DonationsPage.css';
import { useLocation } from 'react-router-dom';
import DonationPage from './donationPage/DonationPage';
import DonationSupportPage from './donationSupportPage/DonationSupportPage';
import { Route, Switch } from 'react-router-dom';

function DonationsPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  return (
    <div className="Donations_page">
      <Switch>
        {/* <Route path="/donations" component={DonationPage} exact /> */}
        {/* <Route path="/donations/:id" component={DonationSupportPage} /> */}
        {/* <Route path="/donations" component={DonationSupportPage} /> */}
        {id ? <DonationSupportPage id={id} /> : <DonationPage />}
      </Switch>
    </div>
  );
}

export default DonationsPage;
